import { Component } from 'react';
import { createRemoteVideoMenuButtonEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { grantModerator } from '../../base/participants/actions';
import { getParticipantById, getUserIdByOccupantId } from '../../base/participants/functions';
import ApiManagerUser from '../../api/ApiManagerUser';
import { USER } from '../../base/util/contants';
import { NOTIFICATION_TIMEOUT_TYPE, showWarningNotification } from '../../notifications';
/**
 * Abstract dialog to confirm granting moderator to a participant.
 */
export default class AbstractGrantModeratorDialog extends Component {
    /**
     * Initializes a new {@code AbstractGrantModeratorDialog} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onSubmit = this._onSubmit.bind(this);
    }
    /**
     * Callback for the confirm button.
     *
     * @private
     * @returns {boolean} - True (to note that the modal should be closed).
     */
    async _onSubmit() {
        const { dispatch, participantID, participantName, t } = this.props;
        if (participantID) {
            const userId = getUserIdByOccupantId(APP.store.getState(), participantID);
            if (userId) {
                const checkGuest = await ApiManagerUser.checkGuestAccount(userId);
                // const participant = getParticipantById(APP.store.getState(), participantID)
                if (checkGuest?.data === USER.ROLE.TMP_GUEST) {
                    // alert(t('dialog.grantGuestModerator', { name: participantName}))  
                    dispatch(showWarningNotification({
                        titleKey: t('dialog.grantGuestModerator', { name: participantName }),
                    }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
                }
                else {
                    sendAnalytics(createRemoteVideoMenuButtonEvent('grant.moderator.button', {
                        'participant_id': participantID
                    }));
                    dispatch(grantModerator(participantID));
                }
            }
        }
        return true;
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code AbstractMuteEveryoneDialog}'s props.
 *
 * @param {IReduxState} state - The redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component.
 * @returns {IProps}
 */
export function abstractMapStateToProps(state, ownProps) {
    return {
        participantName: getParticipantById(state, ownProps.participantID)?.name
    };
}
